import axiosInstance from "../api/axiosInstance"

// GET: List users with pagination, filters, search
export const fetchdiscount = (params) => axiosInstance.get("/admin/discountList", { params });

// GET: Get single user details by ID
export const getDiscountDetail = (id) => axiosInstance.get(`/admin/discountById/${id}`);
// PATCH: Ban or unban user
export const changeDiscountStatus = (id, data) => axiosInstance.put(`/admin/discountUpdate/${id}`, data);

export const deleteDiscount = (ids) =>
  axiosInstance.delete(`/admin/discountDelete/`, {
    data: ids, // 👈 this sends { id: [...] } to backend
  });


export const discountAdd = (data) => axiosInstance.post(`/admin/discountAdd/`, data);
export const discountUpdate = (id, data) => axiosInstance.put(`/admin/discountUpdate/${id}`, data);

